import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BehaviorSubject, Observable } from "rxjs";
import { map } from "rxjs/operators";

import { environment } from "environments/environment";
import { User, Role } from "app/auth/models";
import { ToastrService } from "ngx-toastr";
import { HelperService } from "app/main/services/helper.service";
import { ThemeColors } from "../models/theme-colors";

@Injectable({ providedIn: "root" })
export class AuthenticationService {
  //public
  public currentUser: Observable<User>;

  //private
  private currentUserSubject: BehaviorSubject<User>;
  private apiUrl: string = environment.apiUrl;

  /**
   *
   * @param {HttpClient} _http
   * @param {ToastrService} _toastrService
   */
  constructor(
    private _http: HttpClient,
    private _toastrService: ToastrService,
    private _helper: HelperService
  ) {

    let d = localStorage.getItem('currentUser');
    let user = d ? (this._helper.decodeData(d) == "undefined" ? null : this._helper.decodeData(d)) : null;
    this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(user));
    this.currentUser = this.currentUserSubject.asObservable();

    // this.currentUserSubject = new BehaviorSubject<User>(
    //   JSON.parse(localStorage.getItem("currentUser"))
    // );
    // this.currentUser = this.currentUserSubject.asObservable();
  }

  // getter: currentUserValue
  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  /**
   *  Confirms if user is admin
   */
  get isAdmin() {
    return (
      this.currentUser && this.currentUserSubject.value.role === Role.Admin
    );
  }

  /**
   *  Confirms if user is client
   */
  get isClient() {
    return (
      this.currentUser && this.currentUserSubject.value.role === Role.Client
    );
  }

  /**
   *  get logged in User 'Company Id'
   */
  get getUserCompanyId() {
    if (this.currentUser && this.currentUserSubject.value) {
      return this.currentUserSubject.value.companyId;
    } else {
      return "";
    }
  }

  get getUserId() {
    if (this.currentUser && this.currentUserSubject.value) {
      return this.currentUserSubject.value.userId;
    } else {
      return "";
    }
  }

  get getCompanyName(){
    if (this.currentUser && this.currentUserSubject.value) {
      return this.currentUserSubject.value.companyName;
    } else {
      return "";
    }
  }

  /**
   * User login
   *
   * @param email
   * @param password
   * @returns user
   */
  login(email: string, password: string) {
    return this._http
      .post<any>(`${this.apiUrl}/auth/customerlogin`, { email, password })
      .pipe(
        map((user) => {
          if (user && user.success) {
            // login successful if there's a jwt token in the response
            if (
              user.data &&
              user.data.accessTokens &&
              user.data.accessTokens.token
            ) {
              // store user details and jwt token in local storage to keep user logged in between page refreshes
              this.setUser(user.data);
            }
          }
          return user;
        })
      );
  }

  /**
   * User logout
   *
   */
  logout() {
    // remove user from local storage to log user out
    localStorage.removeItem("currentUser");
    localStorage.removeItem("jwt");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("customThemeColors");
    localStorage.removeItem("permissions");
    // notify
    this.currentUserSubject.next(null);
    this.applyThemeColors();
    window.location.reload();
  }

  /**
   * Set User object in local storage
   *
   */
  setUser(user: any) {
    this.currentUserSubject.next(user);
    localStorage.setItem("jwt", user.accessTokens.token); 
    localStorage.setItem("refreshToken", user.accessTokens.refreshToken);
    localStorage.setItem(
      "currentUser",
      this._helper.encodeData(JSON.stringify(user))
    );
    localStorage.setItem("permissions", this._helper.encodeData(user.customerPortalPermissions)); 
    this.saveThemeColors(user);
  }

  getUser(): User {
    return this.currentUserSubject.value
  }

  getUserPermissions(): Array<number> {
    return this.currentUserSubject.value.customerPortalPermissions;
  }

  saveThemeColors(obj){
    if(obj){
    let theme = new ThemeColors();
    theme.buttonColor = obj.buttonColor;
    theme.pageBackgroundColor = obj.pageBackgroundColor;
    theme.headerColor = obj.headerColor;
    theme.textColor = obj.textColor;
    theme.textHeadingColor = obj.textHeadingColor;
    localStorage.setItem("customThemeColors", JSON.stringify(theme));
    this.applyThemeColors();
    }
  }

  getThemeColors(){
    let d = localStorage.getItem('customThemeColors');
    let obj = d ? (JSON.parse(d) == "undefined" ? null : JSON.parse(d)) : null;
    return obj
  }

  applyThemeColors(): void {
    var obj = this.getThemeColors();
   
    if(obj!=null && obj!='' && obj!="undefined"){
    document.documentElement.style.setProperty('--customBtn', obj.buttonColor);
    document.documentElement.style.setProperty('--customPageBg', obj.pageBackgroundColor);
    document.documentElement.style.setProperty('--customHeader', obj.headerColor);
    document.documentElement.style.setProperty('--customText', obj.textColor);
    document.documentElement.style.setProperty('--customTextHeading', obj.textHeadingColor);
    }
  }
}
